import { apiFunction } from "../../apiCalls/function";
import { ADD_VC_IMG } from "../../apiCalls/urls/officer/urls";

export const getVcData = async (data) => {
    return await apiFunction(`${ADD_VC_IMG}?complexId=${data.complexId}8&date=${data.date}%`, "get", data, true, "admin")
}
